import type { FC } from 'react';

export const ArrowIcon: FC<{
  color?: string;
}> = (props) => (
  <svg
    width="100%"
    height="100%"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 8 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.56113 4.51405C4.23904 4.79298 3.76096 4.79298 3.43887 4.51405L0.541769 2.00508C-0.0581484 1.48554 0.309282 0.5 1.1029 0.5L6.8971 0.5C7.69072 0.5 8.05815 1.48554 7.45823 2.00508L4.56113 4.51405Z"
      fill={props.color || '#E6E6E9'}
    />
  </svg>
);
